module.exports = __webpack_public_path__ + "img/HOME.627999be.svg";